<app-page-breadcrumb pageTitle="Páginas de reserva"></app-page-breadcrumb>

<div class="space-y-4">
  <!-- Controles -->
  <div class="flex items-center justify-between gap-2 flex-wrap">
    <div class="flex items-center gap-2 flex-wrap">
      <input type="text" [(ngModel)]="filtroSearch" (ngModelChange)="cargar()"
        placeholder="Buscar por slug, título..."
        class="px-3 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white w-64">

      <select [(ngModel)]="filtroActive" (ngModelChange)="cargar()"
        class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
        <option value="">Todos</option>
        <option value="true">Activos</option>
        <option value="false">Inactivos</option>
      </select>
    </div>

    <button type="button" (click)="crear()"
      class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
      </svg>
      Nueva página de reserva
    </button>
  </div>

  @if (loading) {
    <div class="flex justify-center items-center py-12">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
      <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando...</span>
    </div>
  }

  @if (error) {
    <div class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
      <p class="text-error-600 dark:text-error-400">{{ error }}</p>
    </div>
  }

  @if (!loading && !error) {
    <div class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
      <div class="max-w-full overflow-x-auto custom-scrollbar">
        <table class="min-w-full">
          <thead class="border-b border-gray-100 dark:border-white/[0.05]">
            <tr>
              <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Slug / Título</th>
              <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Modo</th>
              <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Duración</th>
              <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Pago</th>
              <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Estado</th>
              <th class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400">Acciones</th>
            </tr>
          </thead>

          <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
            @if (links.length === 0) {
              <tr>
                <td colspan="6" class="px-5 py-8 text-center text-gray-500 dark:text-gray-400">
                  No hay booking pages creadas.
                </td>
              </tr>
            }

            @for (link of links; track link.id) {
              <tr>
                <td class="px-4 py-3 text-start">
                  <span class="block font-medium text-gray-800 dark:text-white/90">
                    {{ link.title || link.slug || 'Sin título' }}
                  </span>
                  @if (link.slug) {
                    <span class="block text-xs text-brand-600 dark:text-brand-400 font-mono">/{{ link.slug }}</span>
                  }
                </td>
                <td class="px-4 py-3 text-start text-theme-sm text-gray-700 dark:text-gray-300">
                  <app-badge color="light">{{ getSchedulingLabel(link.schedulingMode) }}</app-badge>
                </td>
                <td class="px-4 py-3 text-start text-theme-sm text-gray-700 dark:text-gray-300">
                  @if (link.defaultDurationMinutes) {
                    {{ link.defaultDurationMinutes }} min
                  } @else {
                    <span class="text-gray-400">—</span>
                  }
                </td>
                <td class="px-4 py-3 text-start text-theme-sm text-gray-700 dark:text-gray-300">
                  @if (link.requiresPayment && link.paymentAmount) {
                    <app-badge color="warning">{{ link.paymentAmount }} {{ link.paymentCurrency }}</app-badge>
                  } @else {
                    <span class="text-xs text-gray-400">Gratis</span>
                  }
                </td>
                <td class="px-4 py-3 text-start">
                  @if (link.isActive) {
                    <app-badge color="success">Activo</app-badge>
                  } @else {
                    <app-badge color="light">Inactivo</app-badge>
                  }
                </td>
                <td class="px-4 py-3 text-center">
                  <div class="flex items-center justify-center gap-2">
                    <button (click)="copiarUrl(link)" title="Copiar URL pública"
                      class="rounded-lg p-2 hover:bg-brand-50 hover:text-brand-600 dark:hover:bg-brand-900/20 transition-colors">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"/>
                      </svg>
                    </button>
                    <button (click)="toggleActive(link)" [title]="link.isActive ? 'Desactivar' : 'Activar'"
                      class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        @if (link.isActive) {
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L18.364 5.636M5.636 18.364l12.728-12.728"/>
                        } @else {
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                        }
                      </svg>
                    </button>
                    <button (click)="editar(link)" title="Editar"
                      class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                      </svg>
                    </button>
                    <button (click)="eliminar(link)" title="Eliminar"
                      class="rounded-lg p-2 hover:bg-error-50 hover:text-error-600 transition-colors">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
</div>
